import { render, staticRenderFns } from "./ExamPaperView.vue?vue&type=template&id=7a206ce5"
import script from "./ExamPaperView.vue?vue&type=script&lang=js"
export * from "./ExamPaperView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports